import React from 'react'
import { useSelector } from 'react-redux'

import MatrixEventTile, {
  haveTileForEvent,
  setTileHandler,
  getHandlerTile,
} from 'matrix-react-sdk/lib/components/views/rooms/EventTile'

import { shouldShowIntegrationMxEvent } from 'components/App/DesktopView/Layout/TicketInspector/Changesets/ExpandedMessage/IntegrationExternalAction'
import selectIntegrationSettingsByProvider from 'ducks/integrations/selectors/selectIntegrationSettingsByProvider'
import useShadowEvent from 'subapps/chat/hooks/useShadowEvent'

const infoMessageExclusionTypes = [
  'm.room.message',
  'm.sticker',
  'm.room.create',
]
const EventTile = ({ readMarkerVisible, ...props }) => {
  // hook to handle shadow event loading
  const mxEvent = useShadowEvent(props.mxEvent)
  const settings = useSelector(selectIntegrationSettingsByProvider)
  const isShadow = mxEvent.getContent()?.msgtype === 'g.shadow'
  const isIntegration = mxEvent
    .getType()
    .match(/^g\.integration\.[^.]+\.external$/)

  if (
    isIntegration &&
    (isShadow || !shouldShowIntegrationMxEvent(mxEvent, settings))
  ) {
    return null
  }
  return (
    <MatrixEventTile
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      mxEvent={mxEvent}
      replacingEventId={mxEvent.replacingEventId()}
      avatarPosition="wrapper"
      messageOverlayPosition="content"
      showSenderAvatar
      infoMessageExclusionTypes={infoMessageExclusionTypes}
    />
  )
}

EventTile.haveTileForEvent = haveTileForEvent
EventTile.setTileHandler = setTileHandler
EventTile.getHandlerTile = getHandlerTile
export default EventTile
